import React from 'react'
import get from 'lodash/get'
import { useQuery } from 'react-query'
import { fetchCampaignData } from '../../../lib/campaigns'

import Content from '../../ui/Content'
import Error from '../../ui/Error'
import Loading from '../../ui/Loading'
import ProgressTiles from '../../ui/ProgressTiles'
import Section from '../../ui/Section'

const CampaignTiles = ({
  alignment,
  background,
  backgroundImage,
  barColor,
  buttonBackground,
  buttonForeground,
  copy,
  copyAlignment,
  foreground,
  items = [],
  size,
  spacing,
  subtitle,
  title,
  titleForeground
}) => {
  const mergeCampaignContent = (campaign, data) => {
    const actions = [{
      label: campaign.donateLabel,
      to: campaign.donateUrl
    }, {
      label: campaign.getStartedLabel,
      to: campaign.getStartedUrl
    }]

    return {
      ...data,
      actions,
      status: 'fetched',
      image: get(campaign, 'image.url') || data.image,
      story: get(campaign, 'story[0].text') ? campaign.story : data.summary,
      name: campaign.title || data.name,
      target: campaign.target ? campaign.target / 100 : data.target,
      hideFundraising: campaign.hideFundraising === 'yes'
    }
  }

  const { data = [], status } = useQuery(
    ['campaigns', items.map(campaign => campaign.uid)],
    () => Promise.all(
      items.map(campaign => (
        fetchCampaignData(campaign.uid)
          .then(data => mergeCampaignContent(campaign, data))
      ))
    ), {
      staleTime: 30000
    }
  )

  return (
    <Section
      alignment={alignment}
      backgroundImage={backgroundImage}
      background={background}
      foreground={foreground}
      size={size}
      spacing={spacing}>

      <Content
        copy={copy}
        copyAlignment={copyAlignment}
        subtitle={subtitle}
        title={title}
        titleForeground={titleForeground}>

        {status === 'loading' && <Loading />}
        {status === 'error' && <Error>There was an error loading the data.</Error>}
        {status === 'success' && (
          <ProgressTiles
            barColor={barColor}
            buttonBackground={buttonBackground}
            buttonForeground={buttonForeground}
            data={data}
            titleForeground={titleForeground}
          />
        )}

      </Content>
    </Section>
  )
}

export default CampaignTiles
